// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  value: "",
  categorie: "",
  type: "",
  annee: "",
  currentPage: 1,
  order: "desc",
  sortField: "nom",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_DOCUMENTATION_GENERALES:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CATEGORIE_DOCUMENTATION_GENERALES:
      return {
        ...state,
        categorie: action.payload,
      };
    case actionTypes.SET_TYPE_DOCUMENTATION_GENERALES:
      return {
        ...state,
        type: action.payload,
      };
    case actionTypes.SET_ANNEE_DOCUMENTATION_GENERALES:
      return {
        ...state,
        annee: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_DOCUMENTATION_GENERALES:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_ORDER_DOCUMENTATION_GENERALES:
      return {
        ...state,
        order: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_DOCUMENTATION_GENERALES:
      return {
        ...state,
        sortField: action.payload,
      };
    default:
      return state;
  }
};

export default rootReducer;
